import React from 'react'
import { l } from '@ds/index'

import { PlanCard } from './PlanCard/PlanCard'
import { useCurrentPlanPriceBreakdown } from './useCurrentPlanPriceBreakdown'

export const CurrentPlanCard = () => {
  const { features, total } = useCurrentPlanPriceBreakdown()

  return (
    <PlanCard
      features={features}
      className="m-t-md"
      isPriceMuted
      title={l.translate('Current Plan')}
      price={<span className="text-secondary">{l.currency(total.amount, total.currency, 0)}</span>}
      priceNote={
        <div className="text-body-sm text-secondary m-y-sm">{l.translate('billed monthly')}</div>
      }
      priceBasis={l.translate('Current price breakdown:')}
      footer={
        <div className="m-t-auto d-flex flex-col">
          <p className="text-body-sm text-secondary">
            {l.translate('If you don’t take any action, you’ll stay on your current plan.')}
          </p>
        </div>
      }
    />
  )
}
